import $ from "jquery";
import WKT from "ol/format/WKT";
import { Image as ImageLayer, Vector as VectorLayer } from "ol/layer";
import { transform } from "ol/proj";
import { ImageWMS, Vector as VectorSource } from "ol/source";
import { containsXY } from "ol/extent";
import * as olStyle from "ol/style";
import React from "react";
import ReactDOM from "react-dom";
//import {BsPlus, BsDash} from "react-icons/bs";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { RiDeleteBin2Line } from "react-icons/ri";
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { createAction, handleActions } from "redux-actions";
import SisOverlay from "store/sis/SisOverlay";
import SisCreator from "../sis/SisCreator";
import SisLayer from "../sis/SisLayer";
import SisMap from "../sis/SisMap";
import SisMeasure from "../sis/SisMeasure";
import SisTree from "../sis/SisTree";

// 액션 타입을 정의해줍니다.
const LOAD_MAP = "LOAD_MAP";
const UPDATE_SIZE = "UPDATE_SIZE";

// 시군 데이터 불러오기
const GET_SGG = "GET_SGG";
// 읍면동 데이터 불러오기
const GET_EMD = "GET_EMD";

// 조회결과 리스트 추가
const ADD_RESULT_ITEM = "ADD_RESULT_ITEM";
const ADD_RESULT_LAYER = "ADD_RESULT_LAYER";
const ADD_RESULT_OVERLAY = "ADD_RESULT_OVERLAY";

// 조회결과 리스트 삭제
const DELETE_RESULT = "DELETE_RESULT";

// 조회결과 체크박스 핸들링
const RESULT_CHECKBOX_HANDLER = "RESULT_CHECKBOX_HANDLER";

// 메인 카테고리 이동
const MAIN_CATEGORY = "MAIN_CATEGORY";

// 메인 부동산 정보조회 이동
const SEARCH_PNU = "SEARCH_PNU";

// 액션 생성 함수를 만듭니다.
export const loadMap = createAction(LOAD_MAP);
export const updateSize = createAction(UPDATE_SIZE);
export const addResultItem = createAction(ADD_RESULT_ITEM);
export const addResultLayer = createAction(ADD_RESULT_LAYER);
export const addResultOverlay = createAction(ADD_RESULT_OVERLAY);
export const deleteResult = createAction(DELETE_RESULT);
export const resultCheckboxHandler = createAction(RESULT_CHECKBOX_HANDLER);
export const getSgg = createAction(GET_SGG);
export const getEmd = createAction(GET_EMD);
export const mainCategory = createAction(MAIN_CATEGORY);
export const searchPnu = createAction(SEARCH_PNU);

const initialState = {
	sisMap: null,
	crsCode: "EPSG:3857",
	lstSgg: [],
	sggSelectList: [],
	defaultSggCd: "12330",
	category: "",
	pnu: "",
};

export default handleActions(
	{
		[LOAD_MAP]: (state, action) => {
			const sisMap = new SisMap(action.payload);
			const sisMeasure = new SisMeasure(sisMap.map);
			const sisCreator = new SisCreator(sisMap.map);
			const sisLayer = new SisLayer(sisMap.map);
			const sisTree = new SisTree({
				id: "tree",
				map: sisMap.map,
				url: "/map/getAllLayers",
				legend: true,
				rootType: "dropdown",
			});

			if (sisMap.x && sisMap.y && sisMap.z) {
				sisMap.view.setCenter([parseFloat(sisMap.x), parseFloat(sisMap.y)]);
				sisMap.view.setZoom(sisMap.z);
			}

			let lstSgg = [];
			let lstEmd = [];
			let sggSelectList = [];

			// 기상 Select Box
			/*$.ajax({
				url: "/map/getSgg",
				type: "post",
				async: false,
				success: (res) => {
					sggSelectList.push({
						sggCd: "0",
						sggNm: "=== 전체 ===",
					});
					res.map((item) => {
						sggSelectList.push({
							sggCd: item.sggCd,
							sggNm: item.sggNm,
						});
						return null;
					});
				},
			});*/

			$.ajax({
				url: "/map/getSgg",
				type: "post",
				async: false,
				success: (res) => {
					//lstSgg = res;
					lstSgg.push({
						sggCd: "0",
						sggNm: "=== 전체 ===",
					});
					res.map((item) => {
						lstSgg.push({
							sggCd: item.sggCd,
							sggNm: item.sggNm,
						});
						return null;
					});
				},
			});

			$.ajax({
				url: "/map/getEmd",
				type: "post",
				async: false,
				data: {
					value: lstSgg[0].sggCd,
				},
				success: (res) => {
					lstEmd = res;
				},
			});

			return {
				...state,
				sisMap,
				sisMeasure,
				sisCreator,
				sisLayer,
				sisTree,
				lstSgg,
				lstEmd,
				sggSelectList,
			};
		},
		[UPDATE_SIZE]: (state, action) => {
			setTimeout(() => {
				state.sisMap.map.updateSize();
			}, action.payload);

			return state;
		},
		[ADD_RESULT_ITEM]: (state, action) => {
			const { data, id, title, closeEvent, checkboxEvent } = action.payload;

			// 전부 체크해제
			const visibleItems = $("#treeResultWrap .checked:not([style*='display: none'])");
			$("#treeResultWrap .checked").hide();
			$("#treeResultWrap .unChecked").show();

			if (visibleItems.length > 0) {
				$.each(visibleItems, (idx, item) => {
					const lyrId = $(item).closest(".item").attr("id");
					if (lyrId === "transportation_traffic") {
						for (var i = 0; i <= 11; i++) {
							const lyr = state.sisLayer.getLayerById(lyrId + "_" + i);
							lyr.setVisible(false);
						}
					}

					const lyr = state.sisLayer.getLayerById(lyrId);
					if (lyr) {
						$(`.sisOverlayWrap`).hide();
						lyr.setVisible(false);
					}
				});
			}

			const wrap = document.querySelector("#treeResultWrap.itemsWrap");
			const item = document.createElement("div");
			item.className = "item";
			item.id = id;

			$(wrap).append(item);

			//ReactDOM.render(data, item);

			const element = (
				<>
					<div className="removeWrap">
                        <img src="/sis/images/map/close.png" alt="삭제"
							 onClick={(evt) => {
                            closeEvent({
                                id: `${id}`,
                            });
                        }}/>
					</div>

					<div
						className="checkboxWrap"
						onClick={() => {
							checkboxEvent({
								id,
							});
						}}
					>
						<MdCheckBoxOutlineBlank className="unChecked checkbox" size="20px" />
						<MdCheckBox className="checked checkbox" size="20px" />
						<span>{title}</span>
					</div>
					{data}
				</>
			);

			ReactDOM.render(element, item);

			return state;
		},
		[ADD_RESULT_LAYER]: (state, action) => {
			
			const { data, id, type, opacity, callback ,clickCallback , title ,filter, layerName} = action.payload;
			
			
			 
			let lyr;
			let source;

			// 공통 클릭 이벤트는 한번만 등록
			/*if (!state.sisMap._clickHandlerRegistered) {
				state.sisMap.map.on('singleclick', (evt) => {
					const viewResolution = state.sisMap.map.getView().getResolution();

					state.sisMap.map.forEachLayerAtPixel(evt.pixel, function (layer) {
						if (layer.get('onClickFeature')) {
							layer.get('onClickFeature')(evt, viewResolution);
						}
					});
					state.sisMap._clickHandlerRegistered = true;
				});
			}*/

			if (type !== "traffic" || type !== "geoserver") {
				lyr = state.sisLayer.addVectorLayer(id, "EPSG:5181", opacity, true);
				source = lyr.getSource();
			}

			let crsCode = action.payload.crsCode ? action.payload.crsCode : "EPSG:4326";

			 if (type === "point") {

				// WKT 객체를 루프 밖에서 생성하여 재사용
				const wktFormat = new WKT();
				const features = []; // 피처를 담을 배열 생성

				data.forEach((ele) => {
					// x, y 좌표 가져오기
					const x = ele.x ?? ele.longitude;
					const y = ele.y ?? ele.latitude;

					let feature;

					// geom 여부에 따라 피처 생성
					if (ele.geom) {
						feature = wktFormat.readFeature(ele.geom);
						feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
						
					} else {
						feature = state.sisLayer.createPointFeature([x, y], crsCode);
					}


					// 스타일 생성 및 적용
					let { color } = action.payload; // 필요한 값만 구조 분해

					if(id==="transportation_parking"){
						if(ele.parkGb==="민영"){
							color = "#00BFA5";
						}else if(ele.parkGb==="공영"){
							color = "#AA00FF";
						}
					}else if(id==="living_park"){
						if(ele.parkType==="근린공원"){
							color = "#304ffe";
						}else if(ele.parkType==="도시농업공원"){
							color = "#ff4081";
						}else if(ele.parkType==="묘지공원"){
							color = "#455a64";
						}else if(ele.parkType==="문화공원"){
							color = "#2196f3";
						}else if(ele.parkType==="소공원"){
							color = "#00c853";
						}else if(ele.parkType==="수변공원"){
							color = "#ff6d00";
						}else if(ele.parkType==="어린이공원"){
							color = "#00bfa5";
						}else if(ele.parkType==="역사공원"){
							color = "#6200ea";
						}else if(ele.parkType==="주제공원"){
							color = "#aa00ff";
						}else if(ele.parkType==="체육공원"){
							color = "#dc143c";
						}
					}else if(id==="living_hospital"){
						let parkGb = ele.gubun
						if(parkGb==="종합병원"){
							color = "#304ffe";
						}else if(parkGb==="요양병원"){
							color = "#ff4081";
						}else if(parkGb==="치과병원"){
							color = "#455a64";
						}else if(parkGb==="정신병원"){
							color = "#2196f3";
						}else if(parkGb==="한방병원"){
							color = "#00c853";
						}else if(parkGb==="의원"){
							color = "#ff6d00";
						}else if(parkGb==="치과의원"){
							color = "#00bfa5";
						}else if(parkGb==="한의원"){
							color = "#6200ea";
						}else if(parkGb==="부속의원"){
							color = "#aa00ff";
						}
					}else if(id==="living_hospital_night"){
						let parkGb = ele.gubun
						if(parkGb==="공공심야어린이병원"){
							color = "#304ffe";
						}else if(parkGb==="협력약국"){
							color = "#ff4081";
						}else if(parkGb==="공공심야약국"){
							color = "#455a64";
						}
					}else if(id==="welfare_oldman"){
						let parkGb = ele.welfareGb
						if(parkGb==="WELGNWE01"){
							color = "#304ffe";
						}else if(parkGb==="WELGNWE02"){
							color = "#ff4081";
						}else if(parkGb==="WELGNWE03"){
							color = "#455a64";
						}else if(parkGb==="WELGNWE04"){
							color = "#2196f3";
						}else if(parkGb==="WELGNWE05"){
							color = "#00c853";
						}else if(parkGb==="WELGNWE06"){
							color = "#ff6d00";
						}
					}else if(id==="welfare_daycare"){
						let parkGb = ele.daycareGb
						if(parkGb==="DCGBND01"){
							color = "#304ffe";
						}else if(parkGb==="DCGBND02"){
							color = "#ff4081";
						}else if(parkGb==="DCGBND03"){
							color = "#455a64";
						}else if(parkGb==="DCGBND04"){
							color = "#2196f3";
						}else if(parkGb==="DCGBND05"){
							color = "#00c853";
						}else if(parkGb==="DCGBND06"){
							color = "#ff6d00";
						}else if(parkGb==="DCGBND07"){
							color = "#2ed5bf";
						}
					}else if(id==="welfare_cultWelf"){
						let parkGb = ele.cultGbn
						if(parkGb==="청소년수련시설"){
							color = "#d5d180";
						}else if(parkGb==="노인복지관"){
							color = "#6ee850";
						}else if(parkGb==="장애인복지관"){
							color = "#75dbb9";
						}else if(parkGb==="종합사회복지관"){
							color = "#d36cbb";
						}
					}else if(id==="safety_cctv"){
						let parkGb = ele.installGbn
						if(parkGb==="CTVGNCTV01"){
							color = "#d5d180";
						}else if(parkGb==="CTVGNCTV02"){
							color = "#6ee850";
						}else if(parkGb==="CTVGNCTV03"){
							color = "#75dbb9";
						}else if(parkGb==="CTVGNCTV04"){
							color = "#d36cbb";
						}else if(parkGb==="CTVGNCTV05"){
							color = "#147ded";
						}else if(parkGb==="CTVGNCTV06"){
							color = "#ed3e2b";
						}else if(parkGb==="CTVGNCTV07"){
							color = "#8852e5";
						}else if(parkGb==="CTVGNCTV08"){
							color = "#d3529b";
						}else if(parkGb==="CTVGNCTV09"){
							color = "#c96741";
						}else if(parkGb==="CTVGNCTV10"){
							color = "#2856cb";
						}else if(parkGb==="CTVGNCTV11"){
							color = "#2ed5bf";
						}
					}else if(id==="safety_security"){
						let parkGb = ele.policeGbn
						if(parkGb==="경찰서"){
							color = "#304ffe";
						}else if(parkGb==="지구대"){
							color = "#ff4081";
						}else if(parkGb==="파출소"){
							color = "#455a64";
						}else if(parkGb==="치안센터"){
							color = "#2196f3";
						}else if(parkGb==="기동순찰대"){
							color = "#00c853";
						}
					}
					
					const style = state.sisLayer.createPointFeatureStyle(5, color);
					feature.setStyle(style);

					features.push(feature); // 생성한 피처를 배열에 추가
				});

				// 배치 추가로 성능 개선
				source.addFeatures(features);
				state.sisMap.view.fit(source.getExtent());
				if(id==="living_weather" ||id==="living_dust" ){
					state.sisMap.view.setZoom(3);
				}

			} else if (type === "polyline") {
				const coordinates = [];
				data.forEach((ele) => {
					const x = ele.x ? ele.x : ele.longitude;
					const y = ele.y ? ele.y : ele.latitude;
					coordinates.push([parseFloat(x), parseFloat(y)]);
				});
				const feature = state.sisLayer.createPolylineFeature(coordinates, "EPSG:4326");
				const fStyle = state.sisLayer.createPolylineFeatureStyle(feature);
				feature.setStyle(fStyle);
				source.addFeature(feature);
				state.sisMap.view.fit(feature.getGeometry().getExtent());
			} else if (type === "traffic") {
				// 교통정보
				lyr = new VectorLayer({
					id: id,
					projection: "EPSG:5181",
					declutter: true,
					zIndex: 9999,
					source: new VectorSource({}),
					style: new olStyle.Style({
						image: new olStyle.Icon({
							src: "/sis/images/map/transportation/icCctv.png",
							scale: 1,
						}),
					}),
				});
				source = lyr.getSource();
				state.sisMap.map.addLayer(lyr);

				for (var i = 0; i <= 11; i++) {
					const utisLyr = new ImageLayer({
						title: "교통정보",
						id: `${id}_${i}`,
						name: "utisLayer",
						korName: "교통정보",
						source: new ImageWMS({
							projection: state.sisMap.view.getProjection().getCode(),
							url: `/UTIS/wms`,
							params: {
								LAYERS: `UTIS:vi_2018_p_lv${11 - i}_d`,
								VERSION: "1.1.1",
								FORMAT: "image/png",
								// TRANSPARENT: true,
								// tiled: true,
							},
							serverType: "geoserver",
						}),
						visible: true,
						minZoom: i - 1,
						maxZoom: i,
						zIndex: 1,
						extent: [-107050.00294274115, 16411.400121516024, 275371.49705725885, 222363.40012151602],
					});

					state.sisMap.map.addLayer(utisLyr);
				}

				// CCTV
				// lyr.setMinZoom(4);
				// lyr.setDeclutter(true);
				data.forEach((ele) => {
					const x = parseFloat(ele.XCOORD);
					const y = parseFloat(ele.YCOORD);

					let geom = [];

					if (isNaN(x)) {
						if (ele.geom) {
							geom = ele.geom;

							let format = new WKT();
							let feature = format.readFeature(geom);
							feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
							geom = feature.getGeometry().getCoordinates();

							// const isContain = containsXY([-107050.00294274115, 16411.400121516024, 275371.49705725885, 222363.40012151602], geom[0], geom[1]);

							source.addFeature(feature);
							// const style = state.sisLayer.createImageStyle("/sis/images/map/transportation/icCctv.png");
							// feature.setStyle(style);
							feature.set("type", "cctv2");
							feature.set("cctvUrl", ele.cctvUrl);
							feature.set("cctvName", ele.cctvNm);
						}
					}  else {
						geom = transform([x, y], "EPSG:4326", "EPSG:5181");

						if (!isNaN(geom[0]) && !isNaN(geom[1])) {
							const isContain = containsXY([-107050.00294274115, 16411.400121516024, 275371.49705725885, 222363.40012151602], geom[0], geom[1]);

							if (isContain) {
								let feature = state.sisLayer.createPointFeature(geom);

								source.addFeature(feature);

								var cctvKind, cctvGid;
								if (ele.CCTVID.substring(0, 3) == "L01") {
									// 서울 지역센터
									cctvKind = "Seoul";
								} else if (ele.CCTVID.substring(0, 3) == "L02") {
									cctvKind = "N";
								} else if (ele.CCTVID.substring(0, 3) == "L03") {
									cctvKind = "O";
								} else if (ele.CCTVID.substring(0, 3) == "L04") {
									cctvKind = "P";
								} else {
									cctvKind = ele.KIND;
								}

								if (ele.ID != null) {
									cctvGid = ele.ID.replace(/\+/g, "%2B");
								} else {
									cctvGid = ele.ID;
								}

								feature.set("cctv", ele);
								feature.set("type", "cctv");
								feature.set("cctvId", ele.CCTVID);
								feature.set("cctvName", ele.CCTVNAME);
								feature.set("kind", cctvKind);
								feature.set("cctvIp", ele.CCTVIP);
								feature.set("cctvch", ele.CH);
								feature.set("id", cctvGid);
								feature.set("cctvPasswd", ele.PASSWD);
								feature.set("cctvPort", ele.PORT);
							}
						}
					}
				});
			} else if (type === "wkt") {
				data.forEach((ele) => {
					var color = "#ff0000";
					if (ele.avgSpeed >= 80) color = "#4d9800";
					else if (ele.avgSpeed >= 40 && ele.avgSpeed < 80) color = "#ffb400";
					else if (ele.avgSpeed < 40) color = "#d11909";
					else color = "#939393";

					const feature = state.sisLayer.createFeatureByWKT(ele.geom, "EPSG:5186");
					const fStyle = state.sisLayer.createPolylineFeatureStyle(feature, 3, color);
					feature.setStyle(fStyle);
					source.addFeature(feature);
				});
			} else if (type === "polygon") {
				let cleanedItem = id.replace(/^[^_]+_/, "").replace(/_/g, "");
				let maxAgeCnt = -Infinity;
				let minAgeCnt = Infinity;

				/*if(id==="population_statistics"){
					if(data.sex==="man"){

					}
				}*/

				// 최대값 & 최솟값 구하기
				const getMinMaxAgeCnt = (data, cleanedItem) => {
					if (!data || data.length === 0) {
						return { max: -Infinity, min: Infinity }; // 빈 데이터 처리
					}
			
					let valueExtractor;
			
					if (cleanedItem.startsWith("statistics")) {
						valueExtractor = (item) => {
							switch (data.sex) {
								case "man": return item.manCnt;
								case "woman": return item.womanCnt;
								default: return item.ageCnt; // 기본값 "0"
							}
						};
					} else if (cleanedItem.startsWith("floating")) {
						valueExtractor = (item) => item.totalCnt;
					} else {
						return { max: -Infinity, min: Infinity }; // 처리할 필요 없는 경우 기본값 반환
					}
			
					return data.reduce(
						(acc, item) => {
							const value = valueExtractor(item);
							acc.max = Math.max(acc.max, value);
							acc.min = Math.min(acc.min, value);
							return acc;
						},
						{ max: -Infinity, min: Infinity }
					);
				};

				if (data.length > 0) {
					({ max: maxAgeCnt, min: minAgeCnt } = getMinMaxAgeCnt(data, cleanedItem));
				}

				// 색상 배열 (5단계 색상 설정)
				const colors = [
					'rgba(255, 255, 178, 0.8)', // 단계 1: 밝은 노란색
					'rgba(254, 204, 92, 0.8)',  // 단계 2: 연한 주황색
					'rgba(253, 141, 60, 0.8)',  // 단계 3: 주황색
					'rgba(240, 59, 32, 0.8)',   // 단계 4: 빨간색
					'rgba(189, 0, 38, 0.8)',    // 단계 5: 진한 빨간색
				];

				// 스타일을 결정하는 함수
				const getFillColor = (value) => {
					const range = maxAgeCnt - minAgeCnt;  // 전체 범위
  					const step = range / 5;             // 각 단계의 범위

					let color = "";
					if (value === undefined) return 'rgba(200, 200, 200, 0.6)'; // 기본 색상 (데이터 없음)

					if (value !== undefined) {
						if (value >= minAgeCnt && value < minAgeCnt + step) {
						  color = colors[0];
						} else if (value >= minAgeCnt + step && value < minAgeCnt + step * 2) {
						  color = colors[1];
						} else if (value >= minAgeCnt + step * 2 && value < minAgeCnt + step * 3) {
						  color = colors[2];
						} else if (value >= minAgeCnt + step * 3 && value < minAgeCnt + step * 4) {
						  color = colors[3];
						} else if (value >= minAgeCnt + step * 4) {
						  color = colors[4];
						}
					  }
					  return color;
				};

				// Feature 클릭 이벤트 핸들러 (한 번만 등록)
				const onFeatureClick = (event) => {
					let topFeature = null;
					let highestZIndex = -1;
					let topLayer = null;

					state.sisMap.map.forEachFeatureAtPixel(event.pixel, (feature, layer) => {
						if (!feature || !layer) return;

						// ✅ 현재 레이어가 OFF된 상태라면 무시
						const layerName = layer.get("id");
						if(layerName.split('_')[0] !== "population"){
							return;
						}

						const currentLayer = state.sisLayer.getLayerById(layerName);
						if (!currentLayer || !layer.getVisible()) return;
				
						// ✅ 현재 feature가 현재 활성화된 레이어의 feature인지 확인
						const layerSource = layer.getSource();
						if (!layerSource || !layerSource.hasFeature(feature)) return;

						const layerZIndex = layer.getZIndex() || 0;

						if (layerZIndex > highestZIndex) {
							highestZIndex = layerZIndex;
							topFeature = feature;
							topLayer = layer;
						}
					});

					if (topFeature) {
						const properties = topFeature.getProperties();
						if (clickCallback) {
							clickCallback(properties); // ✅ 클릭 콜백 실행
						} else {
							alert(`선택한 영역 데이터: ${properties.manCnt ?? properties.womanCnt ?? properties.totalCnt ?? "정보 없음"}`);
						}
					}
				};

				// ✅ 클릭 이벤트가 중복 등록되지 않도록, 한 번만 등록
				if (!state.sisMap.map.hasListener("singleclick", onFeatureClick)) {
					state.sisMap.map.on("singleclick", onFeatureClick);
				}
		
				// 여러 개의 폴리곤 생성 및 추가 (WKT 사용)
				data.forEach((ele) => {
					if (!ele.geom) return; // WKT 데이터가 없으면 건너뜀

					// 변환된 WKT를 사용하여 폴리곤 feature 생성
					const feature = state.sisLayer.createFeatureByWKT(ele.geom, "EPSG:5186");

					feature.set("id",id);
					// `ele` 객체의 각 속성을 동적으로 feature에 설정
					for (const key in ele) {
						if (ele.hasOwnProperty(key) && key !== 'geom') { // 'geom' 제외하고 모든 속성 설정
						feature.set(key, ele[key]);
						}
					}
					

					// feature에 값 설정
					let value = 0; // 기본값 0
					if (cleanedItem.startsWith("statistics")){
						if (data.sex === "man") {
							value = ele.manCnt ?? 0;
						} else if (data.sex === "woman") {
							value = ele.womanCnt ?? 0;
						} else { // data.sex === "0"
							value = ele.ageCnt ?? 0;
						}
						feature.set("age",data.age);
					}else if (cleanedItem.startsWith("floating")){
						value = ele.totalCnt ?? 0;
						feature.set("sex",data.sex);
						feature.set("guBun",data.guBun);
						feature.set("stdTime",data.stdTime);
					}
					
					let fillColor = getFillColor(value)
					// 폴리곤 스타일 적용
					const fStyle = state.sisLayer.createPolygonFeatureStyle("#000", fillColor , value);

					//console.log("값 : " + value + " 컬러값 : " + fillColor);
					//feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					feature.setStyle(fStyle);
					

					
					source.addFeature(feature);
				});

				/*lyr.set("onClickFeature", (feature) => {
					const props = feature.getProperties();
					//const info = props.manCnt ?? props.womanCnt ?? props.totalCnt ?? "정보 없음";
					//alert(`[${lyr.get("title")}] 선택한 영역: ${info}`);
					console.log(props);
				});*/

				// 지도 화면 조정
				state.sisMap.view.fit(source.getExtent());

				//updateClickEvent();
			} else if (type === "geoserver") {
				//let cleanedItem = id.replace(/^[^_]+_/, "");

				/*lyr = new ImageLayer({
					title: title,
					id: `${id}`,
					name: id,
					korName: title,
					source: new ImageWMS({
						projection: "EPSG:5181",
						url: `/map/proxy/wms.do`,
						params: {
							LAYERS: "sde:"+layerName,
							VERSION: "1.1.1",
							FORMAT: "image/png",
							// TRANSPARENT: true,
							// tiled: true,
							CQL_FILTER : filter
						},
						serverType: "geoserver",
					}),
					visible: true,
				});*/

				const lyr = new TileLayer({
					title: title,
					id: `${id}`,
					name: id,
					korName: title,
					source: new TileWMS({
						projection: "EPSG:5181",
						url: `/map/proxy/wms.do`,
						params: {
							LAYERS: `sde:${layerName}`, 
							VERSION: "1.1.1",
							FORMAT: "image/png",
							TRANSPARENT: true
							//CQL_FILTER: filter
						},
						serverType: "geoserver",
					}),
					visible: true,
				});

				state.sisMap.map.addLayer(lyr);

				// 레이어 생성 시 전용 핸들러를 layer 객체에 설정
				/*lyr.set('onClickFeature', (evt, viewResolution) => {
					const source = lyr.getSource();
					const url = source.getFeatureInfoUrl(evt.coordinate, viewResolution, 'EPSG:5181', {
						INFO_FORMAT: 'application/json',
						QUERY_LAYERS: source.getParams().LAYERS
					});

					if (url) {
						fetch(url)
							.then((res) => res.json())
							.then((data) => {
								if (data.features?.length > 0) {
									console.log(`[${lyr.get('title')}] 피처 정보:`, data);
								}
							})
							.catch((err) => {
								console.error('GetFeatureInfo 오류:', err);
							});
					}
				});*/
				//source = lyr.getSource()
				// 지도 화면 조정
				//state.sisMap.view.fit(source.getExtent());
			} else if (type === "workPolyline") {
				const wktFormat = new WKT();
				
				data.forEach((ele) => {
					if (!ele.geom) return; // WKT 데이터가 없으면 건너뛴다.
					
					const feature = wktFormat.readFeature(ele.geom, {
						dataProjection: "EPSG:5186", 
						featureProjection: "EPSG:5186"
					});

					// Feature가 유효하지 않으면 건너뛴다.
					if (!feature || !feature.getGeometry) {
						console.error("Invalid feature:", ele.geom);
						return;
					}
					let color = "#ff0000";
					if (ele.gbn1 === "1공구") {
						color = "#708090"; // 순수 빨강
					} else if (ele.gbn1 === "2공구") {
						color = "#0000ff"; // 오렌지 레드 (주황빛 빨강)
					} else if (ele.gbn1 === "3공구") {
						color = "#00fa9a"; // 딥 핑크 (자주빛 빨강)
					} else if (ele.gbn1 === "4공구") {
						color = "#008000"; // 크림슨 (어두운 빨강)
					} else if (ele.gbn1 === "5공구") {
						color = "#808000"; // 토마토 (밝은 빨강)
					} else if (ele.gbn1 === "6공구") {
						color = "#ff77ff"; // 다크 레드 (가장 어두운 빨강)
					}// 파란색 계열 (7~14공구)
					else if (ele.gbn1 === "7공구") {
						color = "#8b008b"; // 순수 파랑
					} else if (ele.gbn1 === "8공구") {
						color = "#ffbf32"; // 로얄 블루 (밝고 선명한 파랑)
					} else if (ele.gbn1 === "9공구") {
						color = "#8b4513"; // 다저 블루 (밝고 시원한 파랑)
					} else if (ele.gbn1 === "10공구") {
						color = "#ff0000"; // 딥 스카이 블루 (밝은 하늘색)
					} else if (ele.gbn1 === "11공구") {
						color = "#ff1493"; // 스틸 블루 (약간 어두운 파랑)
					} else if (ele.gbn1 === "12공구") {
						color = "#00e35e"; // 카디널 블루 (청록색 계열)
					} else if (ele.gbn1 === "13공구") {
						color = "#000"; // 다크 시안 (어두운 청록색)
					} else if (ele.gbn1 === "14공구") {
						color = "#00ffff"; // 미드나잇 블루 (거의 남색)
					}

					// --- 스타일 적용 로직 수정 ---
					const geometry = feature.getGeometry();
					const geometryType = geometry.getType(); // 지오메트리 타입 확인

					let featureStyle;

					if (geometryType === 'LineString' || geometryType === 'MultiLineString') {
						// 라인 스타일 적용
						if(ele.gbn3 === "하수4"){
							//const fStyle = state.sisLayer.createPolylineFeatureStyle(feature, 3 , color,50, "#ff0000",true);
							featureStyle = state.sisLayer.createPolylineFeatureStyle(feature, 1 , "#FF4500",50, "#ff0000",true);
							//feature.setStyle(fStyle);
						}else{
							//const fStyle = state.sisLayer.createPolylineFeatureStyle(feature, 3 , color);
							featureStyle = state.sisLayer.createPolylineFeatureStyle(feature, 3 , color);
							//feature.setStyle(fStyle);
						}
					}else if (geometryType === 'Point' || geometryType === 'MultiPoint') {
						// 포인트 스타일 적용 (예: 원형 마커)
						/*featureStyle = new Style({
							image: new Circle({
								radius: 7, // 포인트 크기
								fill: new Fill({
									color: color // 채우기 색상
								}),
								stroke: new Stroke({ // 테두리 (선택 사항)
									color: '#ffffff', // 흰색 테두리
									width: 1
								})
							})
						});*/
						featureStyle = state.sisLayer.createPointFeatureStyle(2, '#ff0000');
					}

					if (featureStyle) {
						feature.setStyle(featureStyle);
					}
					//feature.setStyle(fStyle);
				
					// 좌표 변환 적용: EPSG:5186 → EPSG:5181					
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					
					//const fStyle = state.sisLayer.createPolylineFeatureStyle(feature, 3 , color);
					//feature.setStyle(fStyle);

					// Feature 저장 & 지도에 추가
					//features.push(feature);
					source.addFeature(feature);					
				});				
				state.sisMap.view.fit(source.getExtent());

			}
			//if (callback) {
			//	callback();
			//}
			if (callback) {
				setTimeout(() => {
					callback();
				}, 0);
			}
			
			return state;
		},
		[ADD_RESULT_OVERLAY]: (state, action) => {
			const { element, data, id, className, onClick, isTop, isDust, isCCTV, offsetValue, color, noProps ,minZoom, maxZoom, mapZoom  } = action.payload;

			const overlays = state.sisMap.map.getOverlays();
			const deleteOverlays = [];

			overlays.forEach((item) => {
				if (item.id) {
					if (item.id.indexOf("removeOverlay") > -1) deleteOverlays.push(item);
				}
			});

			deleteOverlays.forEach((item) => {
				state.sisMap.map.removeOverlay(item);
			});

			let crsCode = action.payload.crsCode ? action.payload.crsCode : "EPSG:4326";
			let offset = offsetValue ? offsetValue : [5, -10];

			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			if (isDust) {
				overlayElement.className = "sisOverlayWrap sisDustOverlayWrap " + className;
				overlayElement.style.backgroundColor = color;
			} else if (isCCTV) {
				overlayElement.className = "sisOverlayWrap sisCCTVOverlayWrap " + className;
			} else {
				overlayElement.className = "sisOverlayWrap " + className;
			}
			overlayElement.id = `${id}`;

			ReactDOM.render(element, overlayElement);

			let feature, coord;
			let geom = data.geom ? data.geom : null;

			let x = data.x ? data.x : data.longitude;
			let y = data.y ? data.y : data.latitude;

			const convertGeometryToWKT = (feature) => {
				if (!feature || !feature.getGeometry()) {
					console.error("Feature 또는 Geometry가 없습니다.");
					return null;
				}
			
				const format = new WKT();
				const wktString = format.writeFeature(feature);
				
				return wktString;
			};

			/*if (typeof geom === "string") {
				if (geom) {
					let format = new WKT();
					feature = format.readFeature(geom);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					coord = feature.getGeometry().getCoordinates();
				} 
			}else{
				//let format = new WKT();
				//let wktGeom = convertGeometryToWKT(geom);
				//feature = format.readFeature(wktGeom);
				//feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				
				if(geom){
					if (geom.getType() === "MultiPolygon") {
						//coord = geom.getInteriorPoint().getCoordinates();
						//console.log("MultiPolygon Centroid:", centroid);
	
						const extent = geom.getExtent(); // [minX, minY, maxX, maxY]
	
						const centerX = (extent[0] + extent[2]) / 2;
						const centerY = (extent[1] + extent[3]) / 2;
						coord = [centerX, centerY];
						
					} else if (geom.getType() === "MultiLineString") {
						const coordinates = geom.getCoordinates(); // 모든 LineString의 좌표 배열
					
						let totalLength = 0;
						let middlePoint = null;
					
						// 전체 길이 계산
						coordinates.forEach((lineString) => {
							for (let i = 0; i < lineString.length - 1; i++) {
								const dx = lineString[i + 1][0] - lineString[i][0];
								const dy = lineString[i + 1][1] - lineString[i][1];
								totalLength += Math.sqrt(dx * dx + dy * dy);
							}
						});
					
						// 중간 지점 찾기
						let currentLength = 0;
						const targetLength = totalLength / 2;
					
						outerLoop: for (const lineString of coordinates) {
							for (let i = 0; i < lineString.length - 1; i++) {
								const x1 = lineString[i][0], y1 = lineString[i][1];
								const x2 = lineString[i + 1][0], y2 = lineString[i + 1][1];
					
								const dx = x2 - x1;
								const dy = y2 - y1;
								const segmentLength = Math.sqrt(dx * dx + dy * dy);
					
								if (currentLength + segmentLength >= targetLength) {
									const ratio = (targetLength - currentLength) / segmentLength;
									middlePoint = [x1 + ratio * dx, y1 + ratio * dy];
									break outerLoop;
								}
					
								currentLength += segmentLength;
							}
						}
					
						coord = middlePoint || geom.getInteriorPoint().getCoordinates(); // 중앙 좌표 설정
					
					} else{
						coord = geom.getGeometry().getCoordinates();
					}
				}else{
					feature = state.sisLayer.createPointFeature([parseFloat(x), parseFloat(y)], crsCode);
					coord = feature.getGeometry().getCoordinates();
				}
				
			}*/


			// geom이 WKT 문자열일 경우 처리
			if (typeof geom === "string") {
				if (geom) {
					let format = new WKT();
					const feature = format.readFeature(geom);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					geom = feature.getGeometry();  // 여기서 geom을 feature의 geometry로 덮어씀
				}
			}

			// geom이 유효한 객체일 경우
			if (geom) {
				if (geom.getType() === "MultiPolygon") {
					const extent = geom.getExtent(); // [minX, minY, maxX, maxY]
					const centerX = (extent[0] + extent[2]) / 2;
					const centerY = (extent[1] + extent[3]) / 2;
					coord = [centerX, centerY];
				} else if (geom.getType() === "MultiLineString") {
					const coordinates = geom.getCoordinates(); // MultiLineString의 좌표 배열

					let totalLength = 0;
					let middlePoint = null;

					// ZM 처리: Z(고도), M(측정값) 제거
					const cleanCoordinates = coordinates.map(lineString =>
						lineString.map(coord => [coord[0], coord[1]]) // XY만 남김
					);

					// 전체 길이 계산
					cleanCoordinates.forEach((lineString) => {
						for (let i = 0; i < lineString.length - 1; i++) {
							const dx = lineString[i + 1][0] - lineString[i][0];
							const dy = lineString[i + 1][1] - lineString[i][1];
							totalLength += Math.sqrt(dx * dx + dy * dy);
						}
					});

					// 중간 지점 찾기
					let currentLength = 0;
					const targetLength = totalLength / 2;

					outerLoop: for (const lineString of cleanCoordinates) {
						for (let i = 0; i < lineString.length - 1; i++) {
							const x1 = lineString[i][0], y1 = lineString[i][1];
							const x2 = lineString[i + 1][0], y2 = lineString[i + 1][1];

							const dx = x2 - x1;
							const dy = y2 - y1;
							const segmentLength = Math.sqrt(dx * dx + dy * dy);

							if (currentLength + segmentLength >= targetLength) {
								const ratio = (targetLength - currentLength) / segmentLength;
								middlePoint = [x1 + ratio * dx, y1 + ratio * dy];
								break outerLoop;
							}

							currentLength += segmentLength;
						}
					}

					coord = middlePoint || geom.getInteriorPoint().getCoordinates(); // 중앙 좌표 설정

				} else {
					coord = geom.getCoordinates();
				}
			} else {
				if(x){
					feature = state.sisLayer.createPointFeature([parseFloat(x), parseFloat(y)], crsCode);
					coord = feature.getGeometry().getCoordinates();
				}else{
					// geom이 없는 경우 처리 (예: 좌표 값이 없을 때)
					console.error("Geometry is invalid or not provided.");
				}
				
			}
			

			

			let classNm = "";

			if (isTop) classNm = "top";

			const overlay = new SisOverlay(`#${overlayElement.id}`, state.sisMap.map, "bottom-center", offset, classNm);
			if (!noProps) {
				overlay.setPosition(coord);
				// overlay.setPosition(transform([parseFloat(x), parseFloat(y)], crsCode, "EPSG:5181"));
				overlay.setProperties(data);
			} else {
				overlay.setPosition(data.position);
			}

			const close = $(overlayElement).find(".sisOverlayClose");
			if (close.length > 0) {
				close.on("click", () => {
					$(`#${id}`).parent().remove();
					state.sisMap.map.removeOverlay(overlay);
				});
			}

			if (onClick)
				$(overlayElement).on("click", (e) => {
					console.log(e);
					onClick(data, e, overlay);
				});

			

			$(`.lst_${id}`).on("click", () => {
				$(`#${id}`)[0].click();

				const feature = state.sisLayer.createFeatureByWKT(data.geom);
				feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				state.sisMap.view.fit(feature.getGeometry().getExtent());
			});

			if(mapZoom){
				const feature = state.sisLayer.createFeatureByWKT(data.geom);
				feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
				state.sisMap.view.fit(feature.getGeometry().getExtent());
			}

			
			const words = id.split("_");

			
				// 줌 레벨에 따른 제어
				const checkZoomLevel = () => {
					const currentZoom = state.sisMap.map.getView().getZoom();
					// Target the first child of overlayElement
					const firstChild = overlayElement.firstElementChild;
					if(words[1] != "weather" && words[1] != "dust"){
						if ((minZoom && currentZoom < minZoom) || (maxZoom && currentZoom > maxZoom)) {
							overlayElement.style.opacity = "0"; // 오버레이 비표시
							overlayElement.style.pointerEvents = "auto"; // 클릭 활성화
							overlayElement.style.width = "10px";
							overlayElement.style.height = "10px";
							if (firstChild) {
								firstChild.style.display = "none"; // 첫번째 태그 비표시
							}
						} else {
							overlayElement.style.opacity = "1";  // 오버레이 표시
							overlayElement.style.pointerEvents = "auto"; // 클릭 활성화
							overlayElement.style.width = "";
							overlayElement.style.height = "";
							if (firstChild) {
								firstChild.style.display = "block"; // 첫번째 태그 표시
								}
							}
						}
				};

			

			
			

			// 줌 레벨에 따라 오버레이 제어
			checkZoomLevel();
			state.sisMap.map.on("moveend", checkZoomLevel);

			
			
			return state;
		},
		[DELETE_RESULT]: (state, action) => {
			const { id, refresh } = action.payload;

			// console.log("aa");

			if (refresh) {
				// console.log(id);
				const items = $(`[id*=${id}]:not(.btn):not(.sisModalWrap)`);

				items.remove();
				if (id !== "transportation_traffic") {
					state.sisLayer.removeLayerById(id);
				} else {
					state.sisLayer.removeLayerById(id);

					for (var i = 0; i <= 11; i++) {
						state.sisLayer.removeLayerById(id + "_" + i);
					}
				}
				const overlays = state.sisMap.map.getOverlays();
				const deleteOverlays = [];

				overlays.forEach((item) => {
					if (item.id) {
						if (item.id.indexOf(id) > -1) deleteOverlays.push(item);
					}
				});

				deleteOverlays.forEach((item) => {
					state.sisMap.map.removeOverlay(item);
				});
			} else if (window.confirm("정말 삭제하시겠습니까?")) {
				//const items = $(`[id*=${id}]:not(.btn)`);
				let items = $(`#${id}:not(.btn)`);
				//let test =

				items.remove();
				if (id !== "transportation_traffic") {
					state.sisLayer.removeLayerById(id);
				} else {
					state.sisLayer.removeLayerById(id);

					for (var i = 0; i <= 11; i++) {
						state.sisLayer.removeLayerById(id + "_" + i);
					}
				}
				const overlays = state.sisMap.map.getOverlays();
				const deleteOverlays = [];

				overlays.forEach((item) => {
					if (item.id) {
						if (item.id.indexOf(id) > -1) deleteOverlays.push(item);
					}
				});

				deleteOverlays.forEach((item) => {
					state.sisMap.map.removeOverlay(item);
				});
			}

			return state;
		},
		[RESULT_CHECKBOX_HANDLER]: (state, action) => {
			const { id } = action.payload;

			$(`#${id} .checkbox`).toggle();

			const items = $(`[id*=${id}].sisOverlayWrap`);
			$(`[id*=${id}].removeOverlayWrap`).closest("div").remove();

			if (id !== "transportation_traffic") {
				const lyr = state.sisLayer.getLayerById(id);

				// on
				if ($(`#${id} .checkbox.checked`).is(":visible")) {
					items.show();
					if (lyr) lyr.setVisible(true);
				} else {
					items.hide();
					if (lyr) lyr.setVisible(false);
				}
			} else {
				var lyr = state.sisLayer.getLayerById(id);

				// on
				if ($(`#${id} .checkbox.checked`).is(":visible")) {
					if (lyr) lyr.setVisible(true);
				} else {
					if (lyr) lyr.setVisible(false);
				}

				for (var i = 0; i <= 11; i++) {
					lyr = state.sisLayer.getLayerById(id + "_" + i);

					// on
					if ($(`#${id} .checkbox.checked`).is(":visible")) {
						if (lyr) lyr.setVisible(true);
					} else {
						if (lyr) lyr.setVisible(false);
					}
				}

				if ($(`#${id} .checkbox.checked`).is(":visible")) {
					items.show();
				} else {
					items.hide();
				}
			}

			return state;
		},
		[MAIN_CATEGORY]: (state, action) => {
			// console.log(action.payload);
			state.category = action.payload;

			return state;
		},
		[SEARCH_PNU]: (state, action) => {
			// console.log(action.payload);
			state.pnu = action.payload;

			return state;
		},
	},
	initialState
);
